module.exports = "https://static.zego.com/_next/static/images/hero-scooter-9a01db2f33c3b7d10817476b1c60f440.jpg";